import { Controller } from '@hotwired/stimulus';
import { useClickOutside } from 'stimulus-use';

export default class extends Controller {
  connect() {
    useClickOutside(this);
  }

  clickOutside(event) {
    this.dispatch('click', { detail: { event } });
  }
}
